import { computed, inject, type Signal } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { injectUser } from '@quipex/core/auth';
import { PermissionKey } from '@quipex/shared/contracts';
import {
    MANAGE_ORGANISATION_USERS_PERMISSIONS,
    MANAGE_ORGANISATION_USERS_ROUTE,
} from './policy';

export interface ManageOrganisationUsersEntry {
    readonly available: Signal<boolean>;
    readonly route: typeof MANAGE_ORGANISATION_USERS_ROUTE;
}

export function injectManageOrganisationUsersEntry(): ManageOrganisationUsersEntry {
    const user = injectUser();

    return {
        available: user.hasPermission(MANAGE_ORGANISATION_USERS_PERMISSIONS),
        route: MANAGE_ORGANISATION_USERS_ROUTE,
    };
}

export function injectInviteOrganisationUsersEntry(): {
    readonly available: Signal<boolean>;
    readonly target: UrlTree;
} {
    const entry = injectManageOrganisationUsersEntry();
    const canInvite = injectUser().hasPermission([
        PermissionKey.OrgUsersInvite,
    ]);
    return {
        available: computed(() => entry.available() && canInvite()),
        target: inject(Router).createUrlTree([entry.route], {
            queryParams: { inviteUser: true },
        }),
    };
}
